import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white">
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto">
          {/* Brand */}
          <div className="text-center mb-8">
            <img
              src="https://customer-assets.emergentagent.com/job_deslumbrangulo-smart/artifacts/f8ecyy7b_White%20logo%20-%20no%20background.png"
              alt="Deslumbrângulo"
              className="h-10 mx-auto mb-6"
            />
          </div>

          {/* Address */}
          <div className="text-center text-gray-400 mb-8">
            <div className="flex items-center justify-center gap-2 mb-2">
              <MapPin size={18} className="text-brand-green flex-shrink-0" />
              <span className="text-sm">Avenida Júlio Graça n.º 460, 4.º</span>
            </div>
            <div className="text-sm">4480-672 Vila do Conde</div>
          </div>

          {/* Links */}
          <div className="border-t border-gray-800 pt-8">
            <div className="flex flex-col md:flex-row justify-center items-center gap-6">
              <Link to="/" className="text-gray-400 hover:text-brand-green transition-colors text-sm">
                Deslumbrângulo
              </Link>
              <span className="hidden md:block text-gray-700">•</span>
              <a href="#" className="text-gray-400 hover:text-brand-green transition-colors text-sm">
                Política de Privacidade
              </a>
              <span className="hidden md:block text-gray-700">•</span>
              <p className="text-gray-500 text-sm">
                © {new Date().getFullYear()}
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
